<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <ImpersonateBanner />
    <DeletionWarningBanner />
    <div :class="{ 'pt-10': authStore.isImpersonating }">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useConfigStore } from '@/stores/config'
import ImpersonateBanner from '@/components/ImpersonateBanner.vue'
import DeletionWarningBanner from '@/components/DeletionWarningBanner.vue'

const authStore = useAuthStore()
const configStore = useConfigStore()

onMounted(() => {
  // Auth is auto-initialized in the store
  // Load app configuration
  configStore.loadConfig()
})
</script>

<style>
/* Global styles */
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
